import constants from 'constants/index'

const toDropzoneAccept = (accept) => {
  const acceptedTypes = accept?.split(',')?.map((type) => type.trim()) || []

  return acceptedTypes.reduce((dropzoneAccept, acceptedType) => {
    if (!acceptedType.startsWith('.')) {
      return { ...dropzoneAccept, [acceptedType]: [] }
    }

    const mimeType =
      constants.validations.MIME_TYP_VALIDATION[
        acceptedType.slice(1).toLowerCase()
      ] || ''

    return {
      ...dropzoneAccept,
      [mimeType]: [...(dropzoneAccept[mimeType] || []), acceptedType],
    }
  }, {})
}

export default toDropzoneAccept
